var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, MenuSection, Pane, ConfirmationModal, ErrorModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import TableComponent from "../../components/TableComponent";
import { MAX_LIST_OFFSET } from "../../utils/pagingCap";
import NavComponent from "../../components/NavComponent";
import NaturalPersonDetail from "./NaturalPersonDetail";
import { NaturalPersonFilters } from "../../components/NaturalPersonFilters";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { useNaturalPersonFilters } from "../../hooks/useNaturalPersonFilters";
import { useNaturalPersonData } from "../../hooks/useNaturalPersonData";
import { useNaturalPersonTable } from "../../hooks/useNaturalPersonTable";
import { useNaturalPersonActions } from "../../hooks/useNaturalPersonActions";
import { usePublishersData } from "../../hooks/usePublishersData";
import { usePageSize } from "../../hooks/usePageSize";
import { usePermissions } from "../../hooks/usePermissions";
import { useActiveRoles, useActiveRolesLoadFailed, } from "../../utils/permissionsUtils";
import { canSeeSearchFailedStatus } from "../../utils/personFilterStatuses";
import { canFilterProposalOrigin } from "../../utils/personProposalOrigin";
import { useGetCurrentUser } from "../../utils/useCurrentUser";
import { usePersonAuthorityLink } from "../../hooks/usePersonAuthorityLink";
import { PersonAuthorityLinkMenuItems, PersonAuthorityLinkModals, } from "../../components/PersonAuthorityLinkActions";
import { CurrentUserLoadErrorBanner } from "../../components/CurrentUserLoadErrorBanner";
import { formatRecordsFound } from "../../utils/recordsFound";
var NaturalPersonList = function () {
    var _a;
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var _b = useState(true), filterPaneIsVisible = _b[0], setFilterPaneIsVisible = _b[1];
    var _c = usePermissions(), isPublisher = _c.isPublisher, canCreateNaturalPerson = _c.canCreateNaturalPerson;
    var activeRoles = useActiveRoles();
    var rolesLoadFailed = useActiveRolesLoadFailed() && activeRoles === undefined;
    var canSeeSearchFailed = canSeeSearchFailedStatus(activeRoles);
    // "Původ návrhu" is offered to agency workers only, and not applied from the
    // URL before the roles are known (DB-899).
    var canFilterByProposalOrigin = canFilterProposalOrigin(activeRoles);
    var currentUser = useGetCurrentUser().data;
    var myOrganizationSourceId = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.sourceId;
    var filtersHook = useNaturalPersonFilters(canSeeSearchFailed, 
    // A failed roles fetch decides too: the filters then fall back to the
    // ones every user may see (no SEARCH_FAILED).
    activeRoles !== undefined || rolesLoadFailed, canFilterByProposalOrigin);
    var _d = usePublishersData(filtersHook.publisherQuery, filtersHook.filters.proposerId), publishers = _d.publishers, publishersLoading = _d.publishersLoading, selectedPublisher = _d.selectedPublisher;
    var _e = usePageSize(), pageSize = _e.pageSize, createPageSizeHandler = _e.createPageSizeHandler;
    var dataHook = useNaturalPersonData(filtersHook.appliedFilters, filtersHook.buildQuery, pageSize, filtersHook.filtersReady);
    var actionsHook = useNaturalPersonActions();
    var columns = useNaturalPersonTable(actionsHook.handleRowClick).columns;
    var authorityLink = usePersonAuthorityLink({
        kind: "natural",
        person: actionsHook.selectedNaturalPerson,
        onUpdated: function (person) {
            actionsHook.setSelectedNaturalPerson(person);
            dataHook.refetch();
        },
        onMerged: function (target) {
            actionsHook.handleRowClick(target);
            dataHook.refetch();
        },
    });
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleApplyFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var handleMyProposals = isPublisher && myOrganizationSourceId
        ? function () {
            dataHook.resetPageOffset();
            filtersHook.applyMyProposals(myOrganizationSourceId);
        }
        : undefined;
    var source = createStripesSource({
        ky: null,
        data: dataHook.naturalPersonsData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading || dataHook.isWaitingForFilters,
        isError: dataHook.isError,
        isLoaded: true,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    return (React.createElement(React.Fragment, null,
        actionsHook.isModalOpen && (React.createElement(ConfirmationModal, { open: actionsHook.isModalOpen, heading: formatMessage({
                id: "ui-br-agency.natural-person.delete.modal.heading",
            }), message: actionsHook.modalMessage, onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!actionsHook.modalAction) return [3 /*break*/, 2];
                            return [4 /*yield*/, actionsHook.modalAction()];
                        case 1:
                            _a.sent();
                            dataHook.refetch();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); }, onCancel: actionsHook.closeModal, confirmLabel: formatMessage({
                id: "ui-br-agency.button.delete",
            }), cancelLabel: formatMessage({
                id: "ui-br-agency.button.cancel",
            }), buttonStyle: "primary" })),
        actionsHook.errorOpen && (React.createElement(ErrorModal, { open: true, label: formatMessage({ id: "ui-br-agency.error" }), content: actionsHook.errorMessage, onClose: actionsHook.closeError })),
        React.createElement(PersonAuthorityLinkModals, { link: authorityLink }),
        React.createElement(RecekPaneSet, null,
            filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-agency.pane.title.navigation",
                }) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null),
                    React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                    React.createElement(NaturalPersonFilters, { filters: filtersHook.filters, publishers: publishers, publishersLoading: publishersLoading, selectedPublisher: selectedPublisher, onFilterChange: filtersHook.handleFilterChange, onStatusChange: filtersHook.handleStatusChange, onPublisherInput: filtersHook.handlePublisherInput, onApplyFilters: handleApplyFilters, onMyProposals: handleMyProposals, hasUnappliedChanges: filtersHook.hasUnappliedChanges(), canSeeSearchFailed: canSeeSearchFailed, showProposalOriginFilter: canFilterByProposalOrigin })))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.table.title" }), paneSub: formatRecordsFound(formatMessage, dataHook.totalRecords, dataHook.totalRecordsExact), actionMenu: canCreateNaturalPerson
                    ? function (_a) {
                        var onToggle = _a.onToggle;
                        return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                            React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    onToggle();
                                    history.push("/bragency/natural-persons/create");
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
                    }
                    : undefined },
                React.createElement(CurrentUserLoadErrorBanner, { show: rolesLoadFailed }),
                React.createElement(TableComponent, { data: dataHook.naturalPersonsData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, maxOffset: MAX_LIST_OFFSET, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source })),
            actionsHook.selectedNaturalPerson && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.natural-person.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: actionsHook.canEditSelectedPerson ||
                    actionsHook.canDeleteSelectedPerson ||
                    actionsHook.canReportChange ||
                    authorityLink.canManage ||
                    authorityLink.canMergeDuplicates
                    ? function (_a) {
                        var onToggle = _a.onToggle;
                        return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                            actionsHook.canEditSelectedPerson && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    var _a;
                                    return history.push("/bragency/natural-persons/edit/".concat((_a = actionsHook.selectedNaturalPerson) === null || _a === void 0 ? void 0 : _a.id));
                                }, fullWidth: true },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" }))),
                            actionsHook.canReportChange && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    var _a;
                                    return history.push("/bragency/natural-persons/report-change/".concat((_a = actionsHook.selectedNaturalPerson) === null || _a === void 0 ? void 0 : _a.id));
                                }, fullWidth: true },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.button.reportChange" }))),
                            actionsHook.canDeleteSelectedPerson && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    return actionsHook.openDeleteConfirm(actionsHook.selectedNaturalPerson);
                                }, fullWidth: true },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" }))),
                            React.createElement(PersonAuthorityLinkMenuItems, { link: authorityLink, onToggle: onToggle })));
                    }
                    : undefined },
                React.createElement(NaturalPersonDetail, { naturalPerson: actionsHook.selectedNaturalPerson }))))));
};
export default NaturalPersonList;
